<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title
      :title="{ name: '系统配置管理', path: '/system/baseSet' }"
      :button-array="buttonArray"
      @openSaveOrEdit="openSaveOrEdit(1)"
    ></Title>
    <div style="">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="6">
            <el-input placeholder="配置名" v-model="qparam.setName" />
          </el-col>
          <el-col :span="6">
            <el-input placeholder="配置值" v-model="qparam.setValue" />
          </el-col>
          <el-col :span="6">
            <el-button
              icon="el-icon-refresh-left"
              type="primary"
              @click="resetQparam"
              >重置</el-button
            >

            <el-button
              icon="el-icon-search"
              type="primary"
              @click="getAllSysbaseSet"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div style="margin-top: 20px">
      <el-card class="box-card" style="min-height: 650px">
        <el-table
          :data="baseSetData"
          :header-cell-style="{
            background: 'rgb(245,245,245)',
            color: 'black',
          }"
          :cell-style="{ color: 'black' }"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          lazy
          row-key="baseSetId"
        >
          <el-table-column fixed prop="setName" label="设置名称" align="center">
          </el-table-column>
          <el-table-column prop="setValue" label="设置值" align="center">
          </el-table-column>
          <el-table-column prop="setDesc" label="描述" align="center">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="isUse"
            align="center"
            label="启用状态"
            width="180"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.useBoolean"
                active-color="#13ce66"
                @change="
                  (val) => {
                    disableSysbaseSet(val, scope.row.baseSetId);
                  }
                "
                inactive-color="#ff4949"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <el-row>
                <el-col :span="8" v-if="scope.row.setType == 2">
                  <el-button
                    type="text"
                    size="small"
                    STYLE="color: black;"
                    @click="openSaveOrEdit(3, scope.row)"
                    >添加</el-button
                  >
                </el-col>
                <el-col :span="8">
                  <el-button
                    type="text"
                    size="small"
                    STYLE="color: black;"
                    @click="openSaveOrEdit(2, scope.row)"
                    >编辑</el-button
                  >
                </el-col>
                <el-col :span="8">
                  <el-popconfirm
                    title="确定删除该设置吗？"
                    @confirm="deleteSysbaseSet(scope.row.baseSetId)"
                  >
                    <el-button
                      slot="reference"
                      type="text"
                      size="small"
                      STYLE="color: black;"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 30, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-count="totlePages"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog
      :before-close="closeWindow"
      :title="dialogTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="640px"
    >
      <BaseSetEdit
        @closeWindow="closeWindow"
        :setForm="baseSetForm"
      ></BaseSetEdit>
    </el-dialog>
  </div>
</template>

<script>
import Title from "../../Title";
import {
  requestDeleteBaseSet,
  requestDisableBaseSet,
  requestGetAllBaseSetTableList,
  requestGetChildrenSet,
} from "../../../api";
import BaseSetEdit from "./BaseSetEdit";
export default {
  name: "SysbaseSet",
  components: { Title, BaseSetEdit },
  data() {
    return {
      qparam: {
        setName: "",
        setValue: "",
        current: 1,
        size: 10,
      },
      baseSetForm: {
        setName: "",
        setValue: "",
        setDesc: "",
        isUse: 1,
        createTime: "",
      },
      totlePages: null, //总页数
      total: null, //总记录结果行数
      baseSetData: [],
      dialogVisible: false,
      dialogTitle: "新增配置",
      buttonArray: [
        {
          type: "success",
          title: "新增配置",
          method: "openSaveOrEdit",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.getAllSysbaseSet();
    },
    handleCurrentChange(num) {
      this.qparam.current = num;
      this.getAllSysbaseSet();
    },
    async getAllSysbaseSet() {
      const response = await requestGetAllBaseSetTableList(this.qparam);
      if (response.code == 200) {
        this.total = response.total;
        this.baseSetData = response.rows;
      } else {
        this.$message.error(response.msg);
      }
    },
    async disableSysbaseSet(isUse, baseSetId) {
      let state = 2;
      if (isUse) state = 1;
      let param = { baseSetId: baseSetId, use: state };
      const response = await requestDisableBaseSet(param);
      if (response.code == 200) {
        this.$message.success(response.msg);
      } else {
        this.$message.error(response.msg);
      }
    },
    async deleteSysbaseSet(baseSetId) {
      let param = { baseSetId: baseSetId };
      const response = await requestDeleteBaseSet(param);
      console.log(response);
      if (response.code == 200) {
        this.$message.success(response.msg);
        this.getAllSysbaseSet();
      } else {
        this.$message.error(response.msg);
      }
    },
    openSaveOrEdit(type, baseSet) {
      this.dialogTitle = "新增配置";
      if (type == 2) {
        this.dialogTitle = "编辑配置";
        this.baseSetForm = JSON.parse(JSON.stringify(baseSet));
      }
      this.dialogVisible = true;
    },
    closeWindow() {
      this.dialogVisible = false;
      this.baseSetForm = {
        setName: "",
        setValue: "",
        setDesc: "",
        isUse: 1,
        createTime: "",
      };
      this.getAllSysbaseSet();
    },
    resetQparam() {
      this.qparam = {
        setName: "",
        setValue: "",
        current: 1,
        pageSize: 10,
      };
      this.getAllSysbaseSet();
    },
  },
  created() {
    this.getAllSysbaseSet();
  },
};
</script>

<style scoped></style>
